import { styled } from '@mui/material';
import Iconify from 'src/components/iconify';

const IconContainerAvatarStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 20,
  '&.stared': {
    color: theme.palette.warning.main,
  },
}));

export type DocAvatarProps = {
  icon?: string;
  starred?: boolean;
};

export const DocAvatar = ({ icon, starred }: DocAvatarProps) => {
  if (!icon)
    return (
      <IconContainerAvatarStyled className={starred ? 'stared' : ''}>
        <Iconify
          icon={starred ? 'tabler:star-filled' : 'tabler:file-description'}
        />
      </IconContainerAvatarStyled>
    );

  return <em-emoji shortcodes={icon} />;
};
